"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapRequireWithInlineModules = exports.transformationPlugins = exports.inlineModules = void 0;
var consts_1 = require("../consts");
var wix_media_url_1 = __importStar(require("./wix-media-url"));
var wix_font_themes_1 = __importDefault(require("./wix-font-themes"));
exports.inlineModules = Object.create(null); // we use create(null) so method that need to be exported to be used within stylable are not exposed (otherwise you could import toString for instance
exports.inlineModules[consts_1.wixMediaUrlName] = wix_media_url_1.default;
exports.inlineModules[consts_1.wixFontThemesName] = wix_font_themes_1.default;
exports.transformationPlugins = [wix_media_url_1.wixMediaUrlTransformationPlugin];
function wrapRequireWithInlineModules(requireModule, modulesToInline) {
    return function (id) {
        var inlineModule = modulesToInline[id];
        return inlineModule ? inlineModule : requireModule(id);
    };
}
exports.wrapRequireWithInlineModules = wrapRequireWithInlineModules;
//# sourceMappingURL=inline-modules.js.map